import React from 'react'

import { Box } from '@chakra-ui/react'

interface DeviceModalHeaderIProps {
  title: string
}

export const DeviceModalHeader = ({ title }: DeviceModalHeaderIProps) => {
  return (
    <Box px='10' py='6'>
      <Box>
        <Box
          color='#353849'
          fontSize='26px'
          fontWeight='extrabold'
          letterSpacing='-0.4px'
          lineHeight='1'
          mb='3'
        >
          {title}
        </Box>
      </Box>
    </Box>
  )
}
